import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Default copy shown for a save/validation failure. Individual callers may pass a
 * more specific message, but the wording here is the app-wide standard (AC5).
 */
export const DEFAULT_GENERAL_ERROR_MESSAGE =
  "Sorry, we're unable to save your form. Some required fields are still empty or contain invalid information.";

/**
 * Drives the app-wide general error banner shown at the top of the screen when a
 * save/validation event fails. HTTP/server errors continue to use the error modal.
 */
@Injectable({ providedIn: 'root' })
export class GeneralErrorBannerService {
  private readonly messageSubject = new BehaviorSubject<string | null>(null);

  /** Emits the current banner message, or null when the banner should be hidden. */
  readonly message$: Observable<string | null> = this.messageSubject.asObservable();

  /** Show the banner with the given message (defaults to the standard save-failure copy). */
  show(message: string = DEFAULT_GENERAL_ERROR_MESSAGE): void {
    this.messageSubject.next(message);
  }

  /** Hide the banner. */
  clear(): void {
    this.messageSubject.next(null);
  }
}
